import { CheckCircle, XCircle, Clock, Package } from "@phosphor-icons/react";

export default function StatsGrid({ stats, role }) {
  if (!stats) return null;
  const items = [
    { label: "Total submissions", value: stats.total_submissions, Icon: Package, color: "text-yellow-400" },
    { label: "Approved", value: stats.approved, Icon: CheckCircle, color: "text-emerald-400" },
    { label: "Pending review", value: stats.pending, Icon: Clock, color: "text-amber-400" },
    { label: "Rejected", value: stats.rejected, Icon: XCircle, color: "text-rose-400" },
  ];
  if (role !== "influencer") {
    items.unshift({ label: "Campaigns", value: stats.campaigns, Icon: Package, color: "text-blue-400" });
  }
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-3" data-testid="stats-grid">
      {items.map((it) => {
        const Icon = it.Icon;
        return (
          <div key={it.label} className="rounded-xl border border-white/10 bg-zinc-900/60 p-5 card-hover">
            <Icon size={20} weight="duotone" className={it.color} />
            <div className="font-heading font-black text-3xl mt-3 leading-none">{it.value}</div>
            <div className="text-xs text-zinc-500 font-mono uppercase tracking-wide mt-2">{it.label}</div>
          </div>
        );
      })}
    </div>
  );
}
